export const retry = (
  fn,
  retriesLeft = 2,
  interval = 1000,
  callback = () => {},
  onError
) => {
  if (callback) callback();
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch(error => {
        if (error.status >= 400 && error.status < 500) {
          if (onError) {
            onError(error);
          }
          reject(error);
        } else {
          setTimeout(() => {
            if (retriesLeft === 1) {
              reject(error);
              if (onError) {
                onError(error);
              }
              return;
            }

            retry(fn, retriesLeft - 1, interval, callback, onError).then(
              resolve,
              reject
            );
          }, interval);
        }
      });
  });
};
